export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '漫画分类', href: '#index' },
  { label: '精选专题', href: '#carousel' },
  { label: '读者评价', href: '#comments' },
  { label: '关于我们', href: '#about' },
];

export const heroData = {
  tag: '每日更新 · 追更必看',
  title: '古古漫画网 — 国漫日漫韩漫大全',
  slogan: '好看的漫画免费全集下拉式阅读，追更连载不错过',
  description:
    '古古漫画网汇聚海量国漫、日漫、韩漫资源，覆盖热血冒险、恋爱校园、悬疑推理、奇幻异世界等全题材。采用流畅下拉式阅读体验，无需翻页等待，沉浸式追更每一话。每日同步更新最新连载，热门完结漫画全集免费看，你的漫画书架我们帮你填满。',
  stats: [
    { value: '20000+', label: '海量漫画资源' },
    { value: '每日更新', label: '同步追更连载' },
    { value: '永久免费', label: '无付费门槛' },
  ],
  primaryCta: { label: '开始阅读', href: '#cards' },
  secondaryCta: { label: '查看分类', href: '#index' },
};

export const cards = [
  {
    id: 1,
    title: '斗罗大陆',
    tag: '国漫 · 热血',
    desc: '唐三重生异世界，武魂觉醒踏上巅峰之路。史莱克七怪热血集结，魂师大赛燃爆全场。',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20cover%20illustration%20featuring%20a%20young%20warrior%20with%20glowing%20martial%20arts%20energy%20surrounding%20him%2C%20dramatic%20action%20pose%20with%20flowing%20cape%2C%20fantasy%20martial%20arts%20theme%2C%20clean%20stylized%20anime%20art%20style%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20soft%20gradient%20background%20with%20subtle%20energy%20effects%2C%20vibrant%20colors%2C%20editorial%20quality&width=800&height=1120&seq=card-01&orientation=portrait',
  },
  {
    id: 2,
    title: '咒术回战',
    tag: '日漫 · 战斗',
    desc: '虎杖悠仁吞下宿傩手指，踏上咒术师之路。诅咒与战斗交织，涩谷事变震撼人心。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20anime%20manga%20cover%20featuring%20a%20dark-haired%20protagonist%20with%20mysterious%20tattoo-like%20markings%20on%20his%20face%2C%20surrounded%20by%20dark%20energy%20and%20cursed%20spirits%2C%20supernatural%20battle%20theme%2C%20clean%20modern%20anime%20illustration%20style%2C%20dark%20purple%20and%20black%20color%20scheme%20with%20neon%20accents%2C%20soft%20gradient%20background%2C%20editorial%20quality&width=800&height=1120&seq=card-02&orientation=portrait',
  },
  {
    id: 3,
    title: '我独自升级',
    tag: '韩漫 · 系统流',
    desc: 'E级猎人程肖宇濒死后觉醒系统面板，一步步从最弱成长为最强猎人的逆袭传说。',
    image: 'https://readdy.ai/api/search-image?query=A%20sleek%20Korean%20webtoon%20style%20manga%20cover%20featuring%20a%20cool%20black-haired%20hunter%20in%20dark%20modern%20combat%20armor%2C%20holding%20a%20glowing%20dagger%2C%20surrounded%20by%20system%20interface%20holographic%20elements%2C%20dungeon%20exploration%20theme%2C%20clean%20stylized%20digital%20art%2C%20cool%20blue%20and%20silver%20tones%2C%20soft%20gradient%20background%2C%20editorial%20quality&width=800&height=1120&seq=card-03&orientation=portrait',
  },
  {
    id: 4,
    title: '完美世界',
    tag: '国漫 · 仙侠',
    desc: '石昊出生即被夺走至尊骨，于大荒中逆天崛起，以无敌之姿横推诸天万界的史诗传奇。',
    image: 'https://readdy.ai/api/search-image?query=A%20grand%20xianxia%20manga%20cover%20illustration%20featuring%20a%20young%20cultivator%20in%20flowing%20ancient%20Chinese%20robes%2C%20surrounded%20by%20floating%20ancient%20runes%20and%20celestial%20energy%2C%20standing%20atop%20a%20mountain%20peak%20with%20dramatic%20clouds%2C%20epic%20fantasy%20theme%2C%20clean%20stylized%20art%2C%20golden%20and%20jade%20green%20palette%2C%20soft%20gradient%20background%2C%20editorial%20quality&width=800&height=1120&seq=card-04&orientation=portrait',
  },
  {
    id: 5,
    title: '鬼灭之刃',
    tag: '日漫 · 斩鬼',
    desc: '灶门炭治郎为救妹妹踏上斩鬼之旅，水之呼吸剑技华丽绽放，无限城决战催人泪下。',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Japanese%20anime%20manga%20cover%20featuring%20a%20young%20swordsman%20with%20a%20nichirin%20blade%2C%20water%20dragon%20effects%20flowing%20around%20him%2C%20traditional%20Japanese%20aesthetic%20with%20modern%20anime%20style%2C%20demon%20slayer%20theme%2C%20clean%20illustration%2C%20deep%20blue%20and%20crimson%20colors%2C%20soft%20gradient%20background%2C%20editorial%20quality&width=800&height=1120&seq=card-05&orientation=portrait',
  },
];

export const indexItems = [
  { id: 1, icon: 'ri-fire-line', label: '热血冒险', count: '3,280部', desc: '燃爆肾上腺的战斗与冒险故事' },
  { id: 2, icon: 'ri-heart-pulse-line', label: '恋爱校园', count: '2,450部', desc: '青春悸动的甜蜜恋爱物语' },
  { id: 3, icon: 'ri-ghost-line', label: '悬疑推理', count: '1,860部', desc: '烧脑反转的悬疑推理神作' },
  { id: 4, icon: 'ri-rocket-line', label: '奇幻异世界', count: '2,920部', desc: '穿越异世界的奇幻冒险之旅' },
  { id: 5, icon: 'ri-sword-line', label: '仙侠修真', count: '1,540部', desc: '御剑飞仙的修真问道之路' },
  { id: 6, icon: 'ri-emotion-laugh-line', label: '搞笑日常', count: '2,110部', desc: '轻松解压的爆笑日常喜剧' },
  { id: 7, icon: 'ri-moon-line', label: '都市异能', count: '1,730部', desc: '现代都市中的超能力对决' },
  { id: 8, icon: 'ri-shield-star-line', label: '武侠江湖', count: '980部', desc: '刀光剑影的快意恩仇世界' },
  { id: 9, icon: 'ri-gamepad-line', label: '游戏电竞', count: '1,250部', desc: '虚拟与现实交织的游戏人生' },
];

export const comments = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20circular%20user%20avatar%20portrait%20in%20flat%20illustration%20style%2C%20young%20Asian%20male%2C%20simple%20warm%20beige%20background%2C%20clean%20modern%20vector%20art%2C%20friendly%20expression&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '追了三年了，古古漫画的更新速度真的没话说！每次新一话出来这里都是最快的，而且下拉式阅读太舒服了，一口气能看几百话。推荐给了好多朋友，大家都入坑了。',
    comic: '正在追《斗罗大陆》',
    date: '2024年7月25日',
  },
  {
    id: 2,
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20circular%20user%20avatar%20portrait%20in%20flat%20illustration%20style%2C%20young%20Asian%20female%2C%20simple%20warm%20beige%20background%2C%20clean%20modern%20vector%20art%2C%20smiling%20expression&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '从微博上看到推荐过来的，国漫资源真的很全！特别喜欢这里的分类索引，找冷门佳作特别方便。韩漫也更新很快，我独自升级全网最快就在这里了。',
    comic: '正在追《我独自升级》',
    date: '2024年7月23日',
  },
  {
    id: 3,
    name: '熬夜追更人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20circular%20user%20avatar%20portrait%20in%20flat%20illustration%20style%2C%20young%20Asian%20male%20with%20glasses%2C%20simple%20warm%20beige%20background%2C%20clean%20modern%20vector%20art%2C%20enthusiastic%20expression&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '作为一个看了十几年漫画的老书虫，古古漫画的阅读体验确实顶。没有广告弹窗打扰，下拉式阅读流畅得飞起，收藏夹功能也很实用。希望平台越做越好！',
    comic: '正在追《完美世界》',
    date: '2024年7月20日',
  },
];

export const updates = [
  {
    id: 1,
    date: '07-28 14:30',
    title: '《斗罗大陆》第358话更新',
    desc: '唐三突破封号斗罗，海神九考进入最终阶段，波赛西现身揭示终极试炼。',
    tag: '热门',
  },
  {
    id: 2,
    date: '07-28 12:15',
    title: '《我独自升级》第179话更新',
    desc: '程肖宇面对君主级魔兽，暗影军团全员集结，最终决战一触即发。',
    tag: '新番',
  },
  {
    id: 3,
    date: '07-28 10:00',
    title: '《完美世界》第426话更新',
    desc: '石昊踏入仙域秘境，遭遇上古大能残魂，至尊骨异变引发天地异象。',
    tag: '热门',
  },
  {
    id: 4,
    date: '07-28 08:45',
    title: '《咒术回战》第262话更新',
    desc: '五条悟vs两面宿傩的战斗进入白热化，领域展开的终极对决改写咒术界格局。',
    tag: '爆更',
  },
  {
    id: 5,
    date: '07-27 20:00',
    title: '新作上架《剑来》全集上线',
    desc: '烽火戏诸侯原著改编，陈平安持剑走江湖，文圣一脉的浩然正气席卷全网。',
    tag: '新番',
  },
  {
    id: 6,
    date: '07-27 18:30',
    title: '《鬼灭之刃》无限城篇连载开启',
    desc: '炭治郎等人突入无限城，上弦之鬼全员登场，最终决战篇正式拉开帷幕。',
    tag: '爆更',
  },
  {
    id: 7,
    date: '07-27 15:00',
    title: '七月新番导览专题上线',
    desc: '盘点本月最值得期待的国漫日漫韩漫新作，追更党不容错过的追番指南。',
    tag: '专题',
  },
];

export const ranking = [
  { rank: 1, title: '斗罗大陆', type: '国漫·热血', heat: '9.8', trend: 'up', desc: '海神九考篇人气登顶，单日阅读量突破800万' },
  { rank: 2, title: '完美世界', type: '国漫·仙侠', heat: '9.7', trend: 'up', desc: '仙域秘境篇引爆全网讨论，好评如潮' },
  { rank: 3, title: '我独自升级', type: '韩漫·系统流', heat: '9.6', trend: 'up', desc: '最终决战篇口碑炸裂，韩漫天花板' },
  { rank: 4, title: '咒术回战', type: '日漫·战斗', heat: '9.5', trend: 'stable', desc: '宿傩战持续霸榜，日漫区人气王' },
  { rank: 5, title: '鬼灭之刃', type: '日漫·斩鬼', heat: '9.4', trend: 'stable', desc: '无限城篇新连载热度飙升中' },
  { rank: 6, title: '剑来', type: '国漫·仙侠', heat: '9.3', trend: 'new', desc: '新作上线首周即冲入热门榜前六' },
];

export const topicTags = [
  { id: 1, label: '国漫崛起', count: '12.8万讨论', icon: 'ri-flag-2-line' },
  { id: 2, label: '日漫推荐', count: '9.6万讨论', icon: 'ri-sun-line' },
  { id: 3, label: '韩漫天花板', count: '7.2万讨论', icon: 'ri-star-line' },
  { id: 4, label: '斗罗大陆', count: '35.6万讨论', icon: 'ri-fire-line' },
  { id: 5, label: '热血战斗', count: '8.3万讨论', icon: 'ri-flashlight-line' },
  { id: 6, label: '仙侠修真', count: '6.5万讨论', icon: 'ri-moon-line' },
  { id: 7, label: '恋爱甜漫', count: '5.8万讨论', icon: 'ri-heart-line' },
  { id: 8, label: '新番速递', count: '10.2万讨论', icon: 'ri-rocket-line' },
  { id: 9, label: '漫画安利', count: '15.4万讨论', icon: 'ri-thumb-up-line' },
];

export const contactInfo = {
  title: '投稿与合作',
  desc: '欢迎漫画作者、汉化组、内容创作者与我们联系。我们为优质国漫提供免费推广资源，为日漫韩漫汉化组提供发布平台。同时也欢迎读者通过以下方式反馈建议、报告问题。',
  email: 'contact@gugumanhua.com',
  qq: '读者交流群：888888888',
  wechat: '公众号：古古漫画网',
  tips: '工作时间：周一至周日 9:00 - 22:00，节假日正常服务',
};

export const faqItems = [
  {
    id: 1,
    q: '古古漫画网的漫画都是免费的吗？',
    a: '是的！古古漫画网上的所有漫画资源均免费提供阅读。我们坚持免费模式，让每一位漫画爱好者都能无门槛享受阅读乐趣。无需充值、无需会员，打开即看。',
  },
  {
    id: 2,
    q: '什么是下拉式阅读？如何使用？',
    a: '下拉式阅读是一种流畅的漫画阅读方式，您只需在阅读页面中向下滚动鼠标或滑动屏幕，漫画内容会自动连续加载，无需点击翻页按钮。相比传统翻页模式，下拉式阅读更加沉浸流畅，一口气看几百话毫无压力。',
  },
  {
    id: 3,
    q: '更新频率如何？能追上最新连载吗？',
    a: '我们的更新团队7x24小时运作，国漫日漫韩漫的最新连载通常在官方发布后1-2小时内即可在古古漫画网上阅读。热门作品如《斗罗大陆》《我独自升级》等几乎与官方同步更新，确保您不错过任何一话。',
  },
  {
    id: 4,
    q: '移动端可以使用吗？阅读体验如何？',
    a: '古古漫画网完美适配手机和平板等移动设备。在手机上同样支持流畅的下拉式阅读，字体清晰、图片自适应屏幕，随时随地追更。我们还提供了APP下载入口，移动端专属优化带来更佳体验。',
  },
  {
    id: 5,
    q: '如何找到我想看的漫画？',
    a: '您可以通过首页的「漫画分类」按题材筛选（热血冒险、恋爱校园、仙侠修真等），也可以使用搜索功能直接查找作品名称。热门排行榜、编辑推荐和话题标签也是发现好漫画的好方式。',
  },
  {
    id: 6,
    q: '漫画加载慢或显示异常怎么办？',
    a: '如果遇到加载问题，建议先检查网络连接状态。若网络正常但仍加载缓慢，可尝试刷新页面或清除浏览器缓存。手机端建议在WiFi环境下阅读高清漫画以获得最佳体验。如问题持续，欢迎联系客服反馈。',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '《斗罗大陆》动画精彩片段',
    desc: '唐三蓝银皇武魂觉醒名场面，燃爆全场的魂师大赛决赛回顾',
    duration: '12:35',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20anime%20video%20thumbnail%20style%20image%20featuring%20a%20martial%20arts%20battle%20scene%20with%20glowing%20blue%20energy%20and%20silver%20grass%20effects%2C%20fantasy%20arena%20background%2C%20anime%20illustration%20style%2C%20vibrant%20colors%2C%20cinematic%20lighting%2C%20dramatic%20action%20composition%2C%20soft%20gradient%20overlay&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《完美世界》石昊独战七神',
    desc: '一人对抗七位神级强者，至尊骨终极爆发，天地变色震撼全场',
    duration: '08:42',
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20anime%20thumbnail%20featuring%20an%20epic%20battle%20scene%20with%20a%20cultivator%20surrounded%20by%20golden%20divine%20energy%2C%20ancient%20Chinese%20fantasy%20aesthetic%2C%20dramatic%20mountain%20and%20cloud%20background%2C%20anime%20illustration%20style%2C%20warm%20golden%20tones%2C%20cinematic%20composition&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《咒术回战》涩谷事变全解析',
    desc: '逐帧分析涩谷事变篇每一个细节，揭秘咒术世界观庞大设定',
    duration: '25:18',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20anime%20thumbnail%20featuring%20a%20dark%20urban%20cityscape%20with%20mysterious%20supernatural%20energy%2C%20modern%20Tokyo%20night%20scene%2C%20anime%20illustration%20style%2C%20purple%20and%20neon%20color%20accents%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20clean%20art%20style&width=800&height=450&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《我独自升级》韩漫改动画PV',
    desc: '备受期待的动画化PV首曝，程肖宇暗影军团视觉效果震撼',
    duration: '03:56',
    image: 'https://readdy.ai/api/search-image?query=A%20sleek%20anime%20style%20thumbnail%20featuring%20a%20shadowy%20figure%20with%20glowing%20purple%20eyes%20and%20dark%20armor%2C%20army%20of%20shadows%20behind%2C%20cool%20dark%20and%20silver%20color%20palette%2C%20anime%20illustration%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20webtoon%20style&width=800&height=450&seq=media-04&orientation=landscape',
  },
];

export const appInfo = {
  title: '随时随地，追更不停',
  desc: '古古漫画网移动端为漫画阅读量身优化，支持离线下载、夜间模式、自动追更提醒等专属功能。下拉式阅读在手机端更加丝滑流畅，让您的碎片时间充满漫画的精彩。',
  features: ['离线下载随时看', '夜间模式护眼', '更新推送提醒', '收藏同步云端', '阅读进度记忆'],
  image: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20colorful%20manga%20comic%20reading%20app%20interface%20on%20screen%2C%20clean%20minimalist%20device%20mockup%2C%20warm%20ambient%20lighting%2C%20professional%20product%20presentation%2C%20soft%20gradient%20background%2C%20app%20UI%20showing%20manga%20pages%20and%20navigation&width=600&height=800&seq=app-mockup&orientation=portrait',
};

export const features = [
  {
    id: 1,
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式流畅阅读',
    desc: '告别繁琐翻页，滚动即阅的沉浸体验。漫画内容自动无缝加载，阅读节奏由您掌控，一口气追完数百话。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '极速更新同步',
    desc: '7x24小时更新保障，官方发布后1-2小时内同步上线。热门连载几乎零时差，让您永远走在追更第一线。',
  },
  {
    id: 3,
    icon: 'ri-global-line',
    title: '三国漫画全覆盖',
    desc: '国漫、日漫、韩漫三大板块一站聚合。从热血国漫到经典日漫再到高分韩漫，您想看的类型这里全都有。',
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '国漫崛起：2024上半年必看国漫盘点',
    desc: '从《斗罗大陆》到《完美世界》，从《剑来》到《一人之下》，国漫正在用质量与诚意征服越来越多读者。本期专题带你回顾上半年不可错过的国漫佳作。',
    image: 'https://readdy.ai/api/search-image?query=A%20grand%20cinematic%20illustration%20featuring%20Chinese%20martial%20arts%20fantasy%20characters%20in%20dynamic%20poses%20with%20flowing%20ancient%20robes%20and%20glowing%20energy%20effects%2C%20epic%20Chinese%20mythology%20inspired%20background%20with%20mountains%20and%20clouds%2C%20anime%20art%20style%2C%20warm%20golden%20and%20crimson%20tones%2C%20cinematic%20widescreen%20composition%2C%20editorial%20quality&width=1400&height=600&seq=carousel-01&orientation=landscape',
    tag: '国漫专题',
  },
  {
    id: 2,
    title: '日漫经典回顾：那些年我们追过的神作',
    desc: '从《火影忍者》到《鬼灭之刃》，从《海贼王》到《咒术回战》，日漫陪伴了一代又一代读者成长。本期带你重温那些让人热泪盈眶的经典瞬间。',
    image: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20anime%20style%20illustration%20featuring%20multiple%20iconic%20Japanese%20anime%20silhouettes%20in%20dynamic%20poses%2C%20retro%20and%20modern%20anime%20aesthetic%20blend%2C%20warm%20sunset%20color%20palette%2C%20emotional%20and%20nostalgic%20atmosphere%2C%20cinematic%20widescreen%20composition%2C%20soft%20gradient%20background%2C%20editorial%20quality&width=1400&height=600&seq=carousel-02&orientation=landscape',
    tag: '日漫专题',
  },
  {
    id: 3,
    title: '韩漫推荐：从《我独自升级》开始的入坑指南',
    desc: '韩漫以其独特的纵版阅读和精良画风迅速俘获全球读者。除了现象级的《我独自升级》，还有哪些韩漫值得一看？本期一网打尽。',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20Korean%20webtoon%20style%20illustration%20featuring%20a%20cool%20hunter%20character%20with%20modern%20combat%20gear%2C%20system%20interface%20holographic%20UI%20elements%20floating%20around%2C%20dungeon%20portal%20background%20with%20blue%20and%20silver%20tones%2C%20sleek%20digital%20art%20style%2C%20cinematic%20widescreen%2C%20editorial%20quality&width=1400&height=600&seq=carousel-03&orientation=landscape',
    tag: '韩漫专题',
  },
  {
    id: 4,
    title: '热血战斗漫画Top10：燃烧你的战斗之魂',
    desc: '战斗是漫画最永恒的主题之一。从武魂觉醒到咒术对决，从念能力到呼吸法，我们精选了十部让你肾上腺素飙升的战斗系漫画佳作。',
    image: 'https://readdy.ai/api/search-image?query=An%20explosive%20action%20anime%20illustration%20featuring%20multiple%20warriors%20in%20intense%20battle%20poses%20with%20energy%20auras%20and%20special%20effects%2C%20dynamic%20fighting%20scene%2C%20vibrant%20fire%20and%20lightning%20effects%2C%20anime%20art%20style%2C%20warm%20orange%20and%20crimson%20color%20palette%2C%20cinematic%20widescreen%2C%20editorial%20quality&width=1400&height=600&seq=carousel-04&orientation=landscape',
    tag: '榜单专题',
  },
  {
    id: 5,
    title: '新番速递：2024年7月最值得追的连载',
    desc: '每月新番眼花缭乱不知从何看起？我们为你梳理了七月最值得关注的国漫日漫韩漫新作，从热门续作到黑马新番，一篇搞定追更计划。',
    image: 'https://readdy.ai/api/search-image?query=A%20fresh%20vibrant%20anime%20illustration%20featuring%20new%20characters%20in%20summer-themed%20settings%2C%20colorful%20and%20energetic%20composition%2C%20modern%20anime%20art%20style%2C%20bright%20summer%20color%20palette%20with%20sky%20blue%20and%20warm%20yellow%20tones%2C%20cinematic%20widescreen%2C%20editorial%20quality%2C%20hopeful%20atmosphere&width=1400&height=600&seq=carousel-05&orientation=landscape',
    tag: '新番专题',
  },
];

export const aboutInfo = {
  title: '关于古古漫画网',
  desc: '古古漫画网成立于2020年，致力于为中文漫画爱好者提供最优质的免费漫画阅读服务。我们聚合了国漫、日漫、韩漫三大板块的海量资源，涵盖热血冒险、恋爱校园、悬疑推理、奇幻异世界、仙侠修真等全题材类型。',
  desc2: '我们坚持「免费、快速、流畅」的核心理念：所有漫画永久免费阅读，每日同步更新最新连载，独创下拉式阅读技术带来沉浸体验。目前古古漫画网已服务超过500万漫画爱好者，日均更新漫画章节超过200话，是国内领先的漫画阅读平台之一。',
  stats: [
    { value: '500万+', label: '累计服务读者' },
    { value: '2万+', label: '漫画资源总量' },
    { value: '200+', label: '日均更新话数' },
    { value: '98%', label: '读者好评率' },
  ],
};

export const footerData = {
  description: '古古漫画网 — 国漫日漫韩漫大全，好看的漫画免费全集下拉式阅读。每日更新最新漫画，追更连载极速体验，您的专属漫画书架。',
  links: [
    { label: '关于我们', href: '#about' },
    { label: '漫画分类', href: '#index' },
    { label: '热门排行', href: '#ranking' },
    { label: '常见问题', href: '#faq' },
    { label: '联系我们', href: '#contact' },
    { label: '最新更新', href: '#updates' },
  ],
  copyright: '© 2024 古古漫画网 Gugumanhua.com. All Rights Reserved.',
  icp: '本站所有漫画资源均来自网络，仅供学习交流使用。如侵犯您的权益，请联系我们删除。',
};